// @flow
export const SET_TARGET_TEMPERATURE = 'hive/heating/target/set';
export const SET_TARGET_TEMPERATURE_UPDATE_PRODUCT = 'hive/heating/target/set/UPDATE_PRODUCT';
export const SET_TARGET_TEMPERATURE_SUCCESS = 'hive/heating/target/set/SUCCESS';
export const GET_TEMPERATURE_HISTORY = 'hive/heating/history/get';
export const GET_TEMPERATURE_HISTORY_SUCCESS = 'hive/heating/history/get/success';
export const SELECT_PERIOD = 'hive/heating/history/select/period';
export const SELECTED_PERIOD = 'SELECTED_PERIOD';
export const TOGGLE_READY_BY = 'hive/heating/ready-by';



// WEBPACK FOOTER //
// ./src/core/state/products/heating/constants.js